import { Box, Collapse, Heading, VStack } from '@chakra-ui/react';
import { ClientContactRow } from '@web-app/components/CallV2/ClientContactRow/ClientContactRow';
import { formatPhoneNumber } from '@web-app/utils/format.utils';
import { FC } from 'react';
import { IoMdLink } from 'react-icons/io';
import { MdOutlineCall } from 'react-icons/md';

interface PreCallJoinInfoUIProps {
  isOpen: boolean;
  patientName?: string;
  appointmentUrl: string;
  phoneNumber?: string;
  phoneNumberFallback?: string;
}

/**
 * Pure UI component for displaying pre-call join information.
 * Displays patient name, appointment URL, and phone number.
 *
 * All data and formatting should be handled by the parent component.
 * Uses collapse animation (slide-up effect) when closing.
 */
export const PreCallJoinInfoUI: FC<PreCallJoinInfoUIProps> = ({
  isOpen,
  patientName,
  appointmentUrl,
  phoneNumber,
  phoneNumberFallback = 'no phone number on file',
}) => {
  return (
    <Collapse in={isOpen} animateOpacity>
      <Box width="100%" data-testid="pre-join-call-info-panel">
        <Box
          bg="surface.subtleAlt"
          borderRadius="sm"
          boxShadow="sm"
          overflow="auto"
          position="relative"
          height="100%"
          pt={2}
          px={4}
        >
          <VStack spacing={2} alignItems="start">
            {patientName && (
              <Heading
                as="h2"
                fontSize="16px"
                lineHeight="20px"
                color="text.default"
              >
                {patientName}
              </Heading>
            )}

            <ClientContactRow LeftIcon={IoMdLink} text={appointmentUrl} />
            <ClientContactRow
              LeftIcon={MdOutlineCall}
              text={formatPhoneNumber(phoneNumber)}
              fallback={phoneNumberFallback}
            />
          </VStack>
        </Box>
      </Box>
    </Collapse>
  );
};
